if ( pplang == 'jp') {

    var jp_strings =
    {
        "globals": {
            "_globalnotice": "登録はこちら",
            "_globalnotice2": regname+"のチケット購入申し込み開始！",
            "_globalnoticereg": "明日のチケット販売の購入方法の手順をお送りしました。メールをご確認ください。",
            "_maintenance": "Ultra Passportは現在ご利用できません。また暫くしてからご確認ください。",
            "_guestnotice": "このページを閲覧するにはログインが必要です。"
        },
        "form_labels": {
            "_fullname": "氏名",
            "_firstname": "名",
            "_lastname": "氏",
            "_email": "メールアドレス",
            "_emailaddy": "メールアドレスを確認してください",
            "_confirmemailaddy": "メールアドレス",
            "_birthday": "生年月日",
            "_location": "地域",
            "_country": "国",
            "_homeevent": "ホームイベント",
            "_gender": "性別",
            "_password": "パスワード",
            "_male": "男性",
            "_female": "女性",
            "_pleaseselect": "選択",
            "_signuptitle": "Ultra Passport 登録",
            "_enteryouremail": "メールアドレスを入力してください。",
            "_backtologin": "ログインに戻る",
            "_requestnewpass": "新パスワードをリクエスト",
            "_on": "On",
            "_off": "Off"
        },
        "labels": {
            "_enrollmentavailable": "現在申込可能",
            "_logintext": "ログイン",
            "_password": "パスワード",
            "_welcome": "ようこそ",
            "_account": "アカウント",
            "_myaccount": "マイ・アカウント",
            "_mypassport": "マイパスポート",
            "_events": "イベント",
            "_points": "ポイント",
            "_updates": "アップデート",
            "_signout": "ログアウト",
            "_signin": "ログイン",
            "_signedin": "ログイン中",
            "_signuptext": "申し込む",
            "_nextlevel": "次のレベル",
            "_forgot": "パスワードを忘れましたか？",
            "_subscribed": "登録済み",
            "_helpcenter": "ヘルプ・センター",
            "_error": "エラー",
            "_silver": "シルバー",
            "_gold": "ゴールド",
            "_platinum": "プラチナム"
        },
        "validation_messages": {
            "_gendertext": "性別を選択してください",
            "_accepttext": "条件を承認してください。"
        },
        "_email_verifications": {
            "_resendverify": "メール認証を再送",
            "_revalidate": "新メールアドレスを有効にするにはメールご確認ください。",
            "_sendingverification": "認証メールを送信中…",
            "_verifysent": "認証メール送信完了",
            "_emailverifydashboard": "アップデートやチケット登録をするには、必ずメールアドレスの確認を行ってください。",
            "_emailverifyupdates": "アップデート情報メールを有効にするには、必ずメールの確認を行ってください。"
        },
        "_edit_page": {
            "_editaccount": "アカウント編集",
            "_nochanges": "変更はありませんでした",
            "_accountupdated": "アカウント更新済み",
            "_emailupdatedstarted": "新メールアドレスの認証が必要です。承認をするにはメールをご確認ください。",
            "_emailupdatedverified": "新メールアドレスが認証されました。",
            "_passwordresetsent": "パスワードリセットのメールを送信しました"
        },
        "_footer_signup": {
            "_startinput": "はじめるにはメールアドレスを入力してください…",
            "_starttext": "アカウントをお持ちですか？イベント、ポイント獲得などに登録するにはお申込みください。",
            "_getstarted": "さあ、はじめよう"
        },
        "_signup_page": {
            "_createaccount": "マイアカウントを作成",
            "_almost": "あと少し…",
            "_almost2": "$user_firstnameさん、Ultra Passport <span class=\"tm\">™</span>アカウント作成おめでとうございます！",
            "_almost3": "アカウントを有効にするには、<strong> $user_email </strong>に送信された確認リンクをクリックして、<strong><u>メールアドレスを確認する必要があります</u></strong> ",
            "_almost4": "メールを受け取っていない場合は、迷惑メールフォルダ</ strong>を確認して<strong><u>アドレス帳</u></strong>]をクリックします。",
            "_almost5": "続ける",
            "_createdsuccess": "アカウントが作成されました",
            "_createdinfo": "アカウント作成中…",
            "_accountactivated": "あなたのアカウントが現在有効になりました。",
            "_accountverified": "あなたのメールアドレスが確認されました。",
            "_passwordresetsuccess": "パスワードのリセット完了"
        },
        "_updates": {
            "_updatestext1": "最新情報を受取るにはログインする必要があります。",
            "_updatestextPending": "最新情報を受け取るにはメールアドレス認証を行ってください。",
            "_updatessubsrcibe": "次の最新情報の購読に申し込みました：",
            "_updatesunsubsrcibe": "次の最新情報の購読を解除しました："
        },
        "_registration": {
            "_rbtnbuy": "今すぐチケット購入",
            "_regbuy": "チケット購入",
            "_rbtnregister": "チケットの登録",
            "_rbtnclosed": "終了",
            "_rbtnsoon": "Coming Soon",
            "_rbtnupdates": "アップデートを受信する",
            "_verifyemailregister": "登録を完了する前にメールアドレス認証をする必要があります。",
            "_regbtnhtml": "登録された",
            "_regerror": "エラーが発生しました",
            "_regerror2": "もう一度お試しください",
            "_regprocessing": "登録処理中…",
            "_registersuccess": "登録が完了しました",
            "_regaccepted": "登録が承認されました <u class='regtype'></u>",
            "_regaccepted2": "チケットの購入手順は、販売開始の24〜48時間前に電子メールにて送信されます。",
            "_regdone1": "登録コード",
            "_regdone2": "あなたは登録しました",
            "_regdone3": "購入手順を再送する"
        },
        "_registration_confirm": {
            "_regtext1": "あなたの情報は最新のものですか？",
            "_regtext2": "あなたの登録情報を確認してください",
            "_regguest1": "イベントに登録するにはサインインする必要があります。",
            "_regpending1": "あと少しです！",
            "_regpending2": "<strong>メールアドレス</strong>を確認して、登録アクセスを解除してください。",
            "_updateinfobtn": "情報を更新する",
            "_confirmreg": "登録を確認する",
            "privacytext": "プライバシーポリシー",
            "termsofuse": "利用規約",
            "_agreesignup": "Ultra Passport™のプライバシーポリシーと利用規約に同意する",
            "_agreesignup2": "サインアップすると、Ultra Passport™のプライバシーポリシーと利用規約に同意したことになります。",
            "_agreeregister": "登録すると、Ultra Passport™のプライバシーポリシーと利用規約に同意したことになります。"
        },
        "_errors": {
            "reset": "無効なメールまたは期限切れのトークン。",
            "create": "作成に失敗しました。クッキーが有効になっていることを確認してください。",
            "general": "おっと！ 何かが間違っているようです。 クッキーが有効になっていることを確認してください。",
            "password": "パスワードは8文字以上でなければなりません。",
            "matchemail" : "Your email addresses don\'t match. Please confirm and reenter your email address.",
            "duplicateemail": "このメールアカウントはすでに使われています。",
            "loginfail": "入力したユーザー名とパスワードが当社の記録と一致しませんでした。 再度確認してからもう一度お試しください",
            "token": "トークンが無効です。ログインして<b>確認メールを再送してください</b>",
            "birthday" : "You must be 16 years of age or older to enroll in Ultra Passport."
        },
        "_passport_labels": {
            "_action": "アクション",
            "_awarded": "授与された",
            "_award": "授与",
            "_pointsexpire": "*ポイントは25ヶ月後に失効します",
            "_qualifydisclaimer": "*「Ultra Festival」*(本開催)には、「Road To Ultra」「Ultra Beach」「Resistance」のみのイベントは含まれません",
            "_benefit": "利点",
            "_sample": "賞与ポイント",
            "_active": "アクティブ",
            "_deleted": "削除された",
            "_btn_dashboard": "ダッシュボード",
            "_btn_benefits": "利益",
            "_btn_qualify": "資格",
            "_btn_points": "マイポイント",
            "_howtoqualify": "資格取得方法"
        },
        "_point_labels": {
            "_points_manual": "パスポート管理者の調整",
            "_points_verify": "承認済みメールアカウント",
            "_points_attend_festival": "Ultra 本開催イベントに参加する",
            "_points_attend_rtu": "Road to Ultra イベントに参加する",
            "_points_away_bonus": "別の大陸イベントに参加する",
            "_points_home_bonus_1": "ホームイベントに参加する",
            "_points_home_bonus_2": "ホームイベントに参加する ×２",
            "_points_home_bonus_3": "ホームイベントに参加する ×３"
        },

        /*"// PHP LABELS": {
            "$newpassword": "新しいパスワードを入力してください",
            "$chooseanewpass": "新しいパスワードを選択する",
            "$enteryouremail": "メールアドレスを入力してください",
            "$optional": "任意"
        },
        "// BUTTON TEXT": {
            "$goback": "戻る",
            "$login": "ログイン",
            "$signup": "サインアップ",
            "$requestnewpass": "新しいパスワードを要求する",
            "$buttonverify": "確認",
            "$resetpassword": "パスワードをリセット",
            "$createmyaccount": "アカウント作成",
            "$updatemyaccount": "アカウント更新",
            "$backtologin": "ログインに戻る",
            "$forgotpass": "パスワードを忘れましたか？"
        },
        "// CONTENT": {
            "$abouttitle": "私について",
            "$upptitle": "パスポート詳細",
            "$updatestext": "最新情報を希望するイベントを選択します。",
            "$allupdates": "最新情報を全て希望する。",
            "$disableall": "全て解除",
            "$terms1": "私は同意します",
            "$terms2": "登録することにより同意されたと",
            "$privacypolicy": "プライバシーポリシー",
            "$termsofuse": "利用規約",
            "$and": "そして",
            "$guestnotice": "このページにアクセスするには、サインインする必要があります。",
            "$searchtext": "入力してイベントを検索してください"
        },
        "// DASHBOARD": {
            "$myaccount": "マイパスポート",
            "$points": "ポイント",
            "$nextlevel": "次のレベル",
            "$name": "氏名",
            "$location": "場所",
            "$customerid": "カスタマーID",
            "$created": "作成した",
            "$level": "レベル",
            "$eventsbtn": "イベント",
            "$updatesbtn": "アップデート",
            "$editaccount": "アカウント編集",
            "$ppdetails": "Passport詳細",
            "$ppid": "Passport ID",
            "$ppunlock": "次のレベルに到達するのに必要なポイント",
            "$status": "ステータス"
        },
        "// URL SLUGS": {
            "$accountpath": "passport",
            "$loginpath": "ログイン",
            "$signuppath": "サインアップ",
            "$lostpath": "紛失",
            "$resetpath": "リセット",
            "$eventspath": "イベント",
            "$verifypath": "確認",
            "$changeemail": "メール変更",
            "$editpath": "編集",
            "$updatespath": "アップデート"
        },
        "// PAGE TITLES": {
            "title_my_passport": "My Passport",
            "title_Login": "ログイン",
            "title_ultra_passport_enrollment": "Ultra Passportの登録",
            "title_reset_your_password": "Passportをリセット",
            "title_update_your_password": "Passportをアップデート",
            "title_events": "イベント",
            "title_verify": "確認",
            "title_change_email": "メールアドレス変更",
            "title_edit_my_account": "マイアカウントを編集",
            "title_manage_updates": "アップデートを管理"
        },*/
        /*"Footer": {
            "email_footer_1": "このメールはUltra Passportから送信されました。",
            "email_footer_2": "これがエラーだと思われる場合は、返信して、お問い合わせください。",
            "email_footer_3": "Powered by Ultra Passport"
        },
        "Account Confirmation": {
            "email_account_confirmation_subject": "Ultra Passportアカウントの確認",
            "email_account_confirmation_message": "Ultra Passportアカウントのメールアドレスを確認してください",
            "email_account_confirmation_button": "アカウントを有効化する"
        },
        "Account Verified": {
            "email_account_verified_subject": "アカウントの確認済み",
            "email_account_verified_message": "Ultra Passportアカウントのメールアドレスを確認しました。 イベントに登録してポイントを獲得し、Ultra Passportのステータスを増やすことができます。",
            "email_account_verified_button": "イベントを表示"
        },
        "New Email Verification": {
            "email_new_email_verification_subject": "新しいメールアドレスを確認してください",
            "email_new_email_verification_message": "新しいメールを確認するには、下のボタンをクリックしてください：",
            "email_new_email_verification_button": "メールアドレスの確認"
        },
        "New Email Verified": {
            "email_new_email_verified_subject": "新しいメールアドレスが確認されました",
            "email_new_email_verified_message": "Ultra Passportアカウントの新しい電子メールアドレスを確認できました。",
            "email_new_email_verified_button": "イベントを表示"
        },
        "Forgot Password": {
            "email_forgot_password_subject": "Ultra Passportのパスワードをリセットする",
            "email_forgot_password_message": "パスワードをリセットするには、下のボタンをクリックしてください",
            "email_forgot_password_button": "パスワードをリセット"
        },
        "Password Reset": {
            "email_password_reset_subject": "パスワードがリセットされました",
            "email_password_reset_message": "パスワードがリセットされたことをお知らせします。",
            "email_password_reset_button": "マイ・アカウント"
        },
        "No Account": {
            "email_no_account_subject": "このアカウントは存在しません",
            "email_no_account_message": "％email％に関連するアカウントは見つかりませんでした。 以下に登録してアカウントを作成してください。",
            "email_no_account_button": "今すぐ登録する"
        },
        "EMAIL LABELS": {
            "email_label_intro": "(name) 様",
            "email_label_intro_guest": "お客様",
            "email_label_confirm_receipt": "このメールは、次の情報を受け取ったことを確認します。 返答が必要な場合は、できるだけ早くご連絡させていただきます。",
            "email_label_sent_from": "送信元",
            "email_label_generated": "このメールは、.$website_linkの投稿から送信されました。 これがエラーだったと思われる場合は、返信してお知らせください。",
            "email_label_contact_request": "お問い合わせする",
            "email_label_point_of_contact": "このメールは、あなたが.get_bloginfo(name).の連絡窓口となっているために届きました。これらのメールを受信しないようにするには、ご連絡ください。",
            "email_label_terms_of_use": "利用規約",
            "email_label_privacy_policy": "プライバシーポリシー"
        },
        "Form Fields": {
            "email_form_success": "完了しました",
            "email_form_thank_you": "(name) [sitename]に連絡していただきありがとうございます。 <br> <br>できるだけ早くお返事させていただきます。"
        }*/
    };


    // Config = '// Config',
    var locale = 'jp';
    var helpurl = 'https://ultrapassport.com/help/';
    var _lwidth = '3em';


  // Globals = '// Globals',
  _globalnotice    = jp_strings['globals']['_globalnotice'];
  _globalnotice2   = jp_strings['globals']['_globalnotice2'];
  _globalnoticereg = jp_strings['globals']['_globalnoticereg'];
  _maintenance     = jp_strings['globals']['_maintenance'];
  _guestnotice     = jp_strings['globals']['_guestnotice'];

  // Labels = '// Labels',
  _fullname            = jp_strings['form_labels']['_fullname'];
  _firstname           = jp_strings['form_labels']['_firstname'];
  _lastname            = jp_strings['form_labels']['_lastname'];
  _email               = jp_strings['form_labels']['_email'];
  _emailaddy           = jp_strings['form_labels']['_emailaddy'];
  _confirmemailaddy    = jp_strings['form_labels']['_confirmemailaddy'];
  _birthday            = jp_strings['form_labels']['_birthday'];
  _location            = jp_strings['form_labels']['_location'];
  _country             = jp_strings['form_labels']['_country'];
  _homeevent           = jp_strings['form_labels']['_homeevent'];
  _gender              = jp_strings['form_labels']['_gender'];
  _password            = jp_strings['form_labels']['_password'];
  _male                = jp_strings['form_labels']['_male'];
  _female              = jp_strings['form_labels']['_female'];
  _pleaseselect        = jp_strings['form_labels']['_pleaseselect'];
  _signuptitle         = jp_strings['form_labels']['_signuptitle'];
  _enteryouremail      = jp_strings['form_labels']['_enteryouremail'];
  _backtologin         = jp_strings['form_labels']['_backtologin'];
  _requestnewpass      = jp_strings['form_labels']['_requestnewpass'];
  _on                  = jp_strings['form_labels']['_on'];
  _off                 = jp_strings['form_labels']['_off'];
  _enrollmentavailable = jp_strings['labels']['_enrollmentavailable'];


  // Text Labels = '// Text Labels',
  _logintext  = jp_strings['labels']['_logintext'];
  _password   = jp_strings['labels']['_password'];
  _welcome    = jp_strings['labels']['_welcome'];
  _account    = jp_strings['labels']['_account'];
  _myaccount  = jp_strings['labels']['_myaccount'];
  _mypassport = jp_strings['labels']['_mypassport'];
  _events     = jp_strings['labels']['_events'];
  _points     = jp_strings['labels']['_points'];
  _updates    = jp_strings['labels']['_updates'];
  _signout    = jp_strings['labels']['_signout'];
  _signin     = jp_strings['labels']['_signin'];
  _signedin   = jp_strings['labels']['_signedin'];
  _signuptext = jp_strings['labels']['_signuptext'];
  _nextlevel  = jp_strings['labels']['_nextlevel'];
  _forgot     = jp_strings['labels']['_forgot'];
  _subscribed = jp_strings['labels']['_subscribed'];
  _helpcenter = jp_strings['labels']['_helpcenter'];
  _error      = jp_strings['labels']['_error'];
  _silver     = jp_strings['labels']['_silver'];
  _gold       = jp_strings['labels']['_gold'];
  _platinum   = jp_strings['labels']['_platinum'];

  // Validation Messages = '// Validation Messages',
  _gendertext = jp_strings['validation_messages']['_gendertext'];
  _accepttext = jp_strings['validation_messages']['_accepttext'];


  // Email Verifications = '// Email Verifications',
  _resendverify         = jp_strings['_email_verifications']['_resendverify'];
  _revalidate           = jp_strings['_email_verifications']['_revalidate'];
  _sendingverification  = jp_strings['_email_verifications']['_sendingverification'];
  _verifysent           = jp_strings['_email_verifications']['_verifysent'];
  _emailverifydashboard = jp_strings['_email_verifications']['_emailverifydashboard'];
  _emailverifyupdates   = jp_strings['_email_verifications']['_emailverifyupdates'];


  // Edit Page = '// Edit Page',
  _editaccount          = jp_strings['_edit_page']['_editaccount'];
  _nochanges            = jp_strings['_edit_page']['_nochanges'];
  _accountupdated       = jp_strings['_edit_page']['_accountupdated'];
  _emailupdatedstarted  = jp_strings['_edit_page']['_emailupdatedstarted'];
  _emailupdatedverified = jp_strings['_edit_page']['_emailupdatedverified'];
  _passwordresetsent    = jp_strings['_edit_page']['_passwordresetsent'];


  // Footer Signup = '// Footer Signup',
  _startinput = jp_strings['_footer_signup']['_startinput'];
  _starttext  = jp_strings['_footer_signup']['_starttext'];
  _getstarted = jp_strings['_footer_signup']['_getstarted'];


  // Signup Page = '// Signup Page',
  _createaccount        = jp_strings['_signup_page']['_createaccount'];
  _almost               = jp_strings['_signup_page']['_almost'];
  _almost2              = jp_strings['_signup_page']['_almost2'];
  _almost3              = jp_strings['_signup_page']['_almost3'];
  _almost4              = jp_strings['_signup_page']['_almost4'];
  _almost5              = jp_strings['_signup_page']['_almost5'];
  _createdsuccess       = jp_strings['_signup_page']['_createdsuccess'];
  _createdinfo          = jp_strings['_signup_page']['_createdinfo'];
  _accountactivated     = jp_strings['_signup_page']['_accountactivated'];
  _accountverified      = jp_strings['_signup_page']['_accountverified'];
  _passwordresetsuccess = jp_strings['_signup_page']['_passwordresetsuccess'];


  // Updates = '// Updates',
  _updatestext1       = jp_strings['_updates']['_updatestext1'];
  _updatestextPending = jp_strings['_updates']['_updatestextPending'];
  _updatessubsrcibe   = jp_strings['_updates']['_updatessubsrcibe'];
  _updatesunsubsrcibe = jp_strings['_updates']['_updatesunsubsrcibe'];


  // Registration = '// Registration',
  _rbtnbuy             = jp_strings['_registration']['_rbtnbuy'];
  _regbuy              = jp_strings['_registration']['_regbuy'];
  _rbtnregister        = jp_strings['_registration']['_rbtnregister'];
  _rbtnclosed          = jp_strings['_registration']['_rbtnclosed'];
  _rbtnsoon            = jp_strings['_registration']['_rbtnsoon'];
  _rbtnupdates         = jp_strings['_registration']['_rbtnupdates'];
  _verifyemailregister = jp_strings['_registration']['_verifyemailregister'];
  _regbtnhtml          = jp_strings['_registration']['_regbtnhtml'];
  _regerror            = jp_strings['_registration']['_regerror'];
  _regerror2           = jp_strings['_registration']['_regerror2'];
  _regprocessing       = jp_strings['_registration']['_regprocessing'];
  _registersuccess     = jp_strings['_registration']['_registersuccess'];
  _regaccepted         = jp_strings['_registration']['_regaccepted'];
  _regaccepted2        = jp_strings['_registration']['_regaccepted2'];
  _regaccepted2_2      = jp_strings['_registration']['_regaccepted2_2'];
  _regaccepted2_3      = jp_strings['_registration']['_regaccepted2_3'];
  _regaccepted3        = jp_strings['_registration']['_regaccepted3'];
  _regdone1            = jp_strings['_registration']['_regdone1'];
  _regdone2            = jp_strings['_registration']['_regdone2'];
  _regdone3            = jp_strings['_registration']['_regdone3'];


  // Registrations Confirm = '// Registrations Confirm',
  _regtext1      = jp_strings['_registration_confirm']['_regtext1'];
  _regtext2      = jp_strings['_registration_confirm']['_regtext2'];
  _regguest1     = jp_strings['_registration_confirm']['_regguest1'];
  _regpending1   = jp_strings['_registration_confirm']['_regpending1'];
  _regpending2   = jp_strings['_registration_confirm']['_regpending2'];
  _updateinfobtn = jp_strings['_registration_confirm']['_updateinfobtn'];
  _confirmreg    = jp_strings['_registration_confirm']['_confirmreg'];


  // Privacy / Terms Notice = '// Privacy / Terms Notice',
  privacytext = jp_strings['privacytext'];
  termsofuse  = jp_strings['termsofuse'];

  // Copyright == '// Copyright ',
  upptextlogo    = 'Ultra Passport<span class="tm">&trade;</span>';
  privacylink    = `<a href="https://ultrapassport.com/privacy-policy" target="_blank">${jp_strings['_registration_confirm']['privacytext']}</a>`;
  termslink      = `<a href="https://ultrapassport.com/terms-of-use" target="_blank">${jp_strings['_registration_confirm']['termsofuse']}</a>`;
  _agreesignup   = jp_strings['_registration_confirm']['_agreesignup'];
  _agreesignup2  = jp_strings['_registration_confirm']['_agreesignup2'];
  _agreeregister = jp_strings['_registration_confirm']['_agreeregister'];


  // Passport Dashboard = '// Passport Dashboard',
  _action            = jp_strings['_passport_labels']['_action'];
  _awarded           = jp_strings['_passport_labels']['_awarded'];
  _award             = jp_strings['_passport_labels']['_award'];
  _benefit           = jp_strings['_passport_labels']['_benefit'];
  _howtoqualify      = jp_strings['_passport_labels']['_howtoqualify'];
  _pointsexpire      = jp_strings['_passport_labels']['_pointsexpire'];
  _qualifydisclaimer = jp_strings['_passport_labels']['_qualifydisclaimer'];
  _active            = jp_strings['_passport_labels']['_active'];
  _deleted           = jp_strings['_passport_labels']['_deleted'];
  _btn_dashboard     = jp_strings['_passport_labels']['_btn_dashboard'];
  _btn_benefits      = jp_strings['_passport_labels']['_btn_benefits'];
  _btn_qualify       = jp_strings['_passport_labels']['_btn_qualify'];
  _btn_points        = jp_strings['_passport_labels']['_btn_points'];

  leveltext = _silver;
  nextlevel = _gold;

  var _birthdayselect = '<div class="datefield"><span class="subfield monthfield"><select class="required" id="birthmonth" name="birthmonth" style="width:80px;display:inline-block"><option value="" disabled selected>MM</option><option value="01">1</option><option value="02">2</option><option value="03">3</option><option value="04">4</option><option value="05">5</option><option value="06">6</option><option value="07">7</option><option value="08">8</option><option value="09">9</option><option value="10">10</option><option value="11">11</option><option value="12">12</option></select></span><span class="spacer">/</span> <span class="subfield dayfield"><select class="required" id="birthday" name="birthday" style="width:80px;display:inline-block" data-field="birthday"><option value="" disabled selected>DD</option><option value="01">1</option><option value="02">2</option><option value="03">3</option><option value="04">4</option><option value="05">5</option><option value="06">6</option><option value="07">7</option><option value="08">8</option><option value="09">9</option><option value="10">10</option><option value="11">11</option><option value="12">12</option><option value="13">13</option><option value="14">14</option><option value="15">15</option><option value="16">16</option><option value="17">17</option><option value="18">18</option><option value="19">19</option><option value="20">20</option><option value="21">21</option><option value="22">22</option><option value="23">23</option><option value="24">24</option><option value="25">25</option><option value="26">26</option><option value="27">27</option><option value="28">28</option><option value="29">29</option><option value="30">30</option><option value="31">31</option></select></span><span class="spacer">/</span> <span class="subfield yearfield"><select class="required" id="birthyear" name="birthyear" style="width:100px;display:inline-block"><option disabled selected>YYYY</option><option value="2017">2017</option><option value="2016">2016</option><option value="2015">2015</option><option value="2013">2013</option><option value="2012">2012</option><option value="2011">2011</option><option value="2010">2010</option><option value="2009">2009</option><option value="2008">2008</option><option value="2007">2007</option><option value="2006">2006</option><option value="2005">2005</option><option value="2004">2004</option><option value="2003">2003</option><option value="2002">2002</option><option value="2001">2001</option><option value="2000">2000</option><option value="1999">1999</option><option value="1998">1998</option><option value="1997">1997</option><option value="1996">1996</option><option value="1995">1995</option><option value="1994">1994</option><option value="1993">1993</option><option value="1992">1992</option><option value="1991">1991</option><option value="1990">1990</option><option value="1989">1989</option><option value="1988">1988</option><option value="1987">1987</option><option value="1986">1986</option><option value="1985">1985</option><option value="1984">1984</option><option value="1983">1983</option><option value="1982">1982</option><option value="1981">1981</option><option value="1980">1980</option><option value="1979">1979</option><option value="1978">1978</option><option value="1977">1977</option><option value="1976">1976</option><option value="1975">1975</option><option value="1974">1974</option><option value="1973">1973</option><option value="1972">1972</option><option value="1971">1971</option><option value="1970">1970</option><option value="1969">1969</option><option value="1968">1968</option><option value="1967">1967</option><option value="1966">1966</option><option value="1965">1965</option><option value="1964">1964</option><option value="1963">1963</option><option value="1962">1962</option><option value="1961">1961</option><option value="1960">1960</option><option value="1959">1959</option><option value="1958">1958</option><option value="1957">1957</option><option value="1956">1956</option><option value="1955">1955</option><option value="1954">1954</option><option value="1953">1953</option><option value="1952">1952</option><option value="1951">1951</option><option value="1950">1950</option><option value="1949">1949</option><option value="1948">1948</option><option value="1947">1947</option><option value="1946">1946</option><option value="1945">1945</option><option value="1944">1944</option><option value="1943">1943</option><option value="1942">1942</option><option value="1941">1941</option><option value="1940">1940</option><option value="1939">1939</option><option value="1938">1938</option><option value="1937">1937</option><option value="1936">1936</option><option value="1935">1935</option><option value="1934">1934</option><option value="1933">1933</option><option value="1932">1932</option><option value="1931">1931</option><option value="1930">1930</option><option value="1929">1929</option><option value="1928">1928</option><option value="1927">1927</option><option value="1926">1926</option><option value="1925">1925</option><option value="1924">1924</option><option value="1923">1923</option><option value="1922">1922</option><option value="1921">1921</option><option value="1920">1920</option><option value="1919">1919</option><option value="1918">1918</option><option value="1917">1917</option><option value="1916">1916</option><option value="1915">1915</option><option value="1914">1914</option><option value="1913">1913</option><option value="1912">1912</option><option value="1911">1911</option><option value="1910">1910</option><option value="1909">1909</option><option value="1908">1908</option><option value="1907">1907</option><option value="1906">1906</option><option value="1905">1905</option><option value="1904">1904</option><option value="1903">1903</option><option value="1902">1902</option><option value="1901">1901</option><option value="1900">1900</option></select></span></div>';

    // Errors : '// Errors',
    var errors = jp_strings['_errors'];

    // Point Labels : '// Point Labels'
    var pointcodes = {
        manual : jp_strings['_point_labels']['_points_manual'],
        verify : jp_strings['_point_labels']['_points_verify'],
        unknown : 'Passport Admin Adjustment',
        attend_festival : jp_strings['_point_labels']['_points_attend_festival'],
        attend_rtu : jp_strings['_point_labels']['_points_attend_rtu'],
        attend_resistance : 'Attend a Resistance Only Event',
        away_bonus : jp_strings['_point_labels']['_points_away_bonus'],
        home_bonus_1 : jp_strings['_point_labels']['_points_home_bonus_1'],
        home_bonus_2 : jp_strings['_point_labels']['_points_home_bonus_2'],
        home_bonus_3 : jp_strings['_point_labels']['_points_home_bonus_3'],
    };
}
